import * as React from "react"

import clsxm from "@/lib/clsxm"

type IconProps = {
  icon: React.ElementType
  className?: string
  size?:
    | `auto`
    | `xs-16`
    | `sm-20`
    | `md-24`
    | `lg-32`
    | `xl-40`
    | `2xl-48`
    | `3xl-56`
}

type AccessibleIconProps = {
  children?: React.ReactNode
  label: string
}

export type Ref = SVGSVGElement

const Icon = React.forwardRef<Ref, IconProps>(
  ({ icon, className, size = `md-24`, ...props }, ref) => {
    const Icon = icon
    return (
      <Icon
        className={clsxm(
          `default`,
          [
            size === `auto` && [`h-auto w-auto`],
            size === `xs-16` && [`h-4 w-4`],
            size === `sm-20` && [`h-5 w-5`],
            size === `md-24` && [`h-6 w-6`],
            size === `lg-32` && [`h-8 w-8`],
            size === `xl-40` && [`h-10 w-10`],
            size === `2xl-48` && [`h-12 w-12`],
            size === `3xl-56` && [`h-14 w-14`],
          ],
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

export default Icon
